import React from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'

// This is a store. It should work for both Network Products & Account Products
// This is pure frontend.
import { SmartContainer, Surface, Stack } from '../../styles/Containers'
import { StyledH3 } from '../../styles/StyledHTML';
import { ModelList } from '../../components/PaginatedList/ModelList';

// Redux
import { searchNetworkProducts } from './redux/networkproduct.actions';
import { FullNetworkProducts } from './redux/networkproduct.selectors';
import { NetworkProductCard } from './NetworkProductCard';

export const NetworkProductList = ({ onSelect }) => {


    // TODO: Get Products
    // TODO: Get Products by Category
    // TODO: Search Paginate

    const dispatch = useDispatch();

    const renderProductCard = (item) => {



        const handleSelect = (item) => {
            if (onSelect) onSelect(item)
            else dispatch(push(`/billing/products/${item.id}`))
        }

        // Guard
        if (!item.full) return (<Surface key={item.id} width="100%">Loading...</Surface>)

        // Product
        return (<NetworkProductCard onClick={(item) => handleSelect(item)} key={item.id} product={item.full} />)

    }

    // Sounds like a job for the Model List

    return (
        <Stack>
            <SmartContainer>
                <StyledH3>Browse our products</StyledH3>
            </SmartContainer>
            <SmartContainer>
                <ModelList
                    model="NetworkProducts"
                    action={searchNetworkProducts}
                    selector={FullNetworkProducts}
                    defaultView="published"
                    variant="cards"
                    defaultLimit="12"
                    customRenderer={renderProductCard} />
            </SmartContainer>
        </Stack>
    )
}

